import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { onboardingApi } from '../api/onboarding.api'

const TOTAL_STEPS = 4

export function useOnboarding() {
  const [currentStep, setCurrentStep] = useState(1)
  const [isLoadingStatus, setIsLoadingStatus] = useState(true)
  const navigate = useNavigate()

  useEffect(() => {
    onboardingApi
      .getStatus()
      .then((res) => {
        if (res.data.data.completed) {
          navigate('/dashboard', { replace: true })
        } else {
          setCurrentStep(res.data.data.step)
        }
      })
      .catch(() => {
        setCurrentStep(1)
      })
      .finally(() => setIsLoadingStatus(false))
  }, [navigate])

  // 4 étapes UI : profil, professeur IA, matières d'intérêt (SPEC.md, Lot J —
  // purement côté client, `onboardingApi` ne connaît que les 3 premières),
  // puis l'écran de fin. `getStatus()` ne renvoie jamais 4 : au rechargement
  // après l'étape 2, le backend est encore à `step: 3`, ce qui reprend
  // exactement à l'étape des matières d'intérêt.
  const nextStep = () => setCurrentStep((prev) => Math.min(prev + 1, TOTAL_STEPS))
  const prevStep = () => setCurrentStep((prev) => Math.max(prev - 1, 1))

  return { currentStep, isLoadingStatus, nextStep, prevStep }
}
